<div class="sticky-header">
    <div class="sticky-header__slot sticky-header__slot--left"><ng-content select="[left]"></ng-content></div>
    <div class="sticky-header__slot"><ng-content></ng-content></div>
    <div class="sticky-header__slot sticky-header__slot--right"><ng-content select="[right]"></ng-content></div>
</div>
